var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgViews(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.267 0C5.6 0 1.615 2.903 0 7c1.615 4.097 5.6 7 10.267 7 4.666 0 8.652-2.903 10.266-7-1.614-4.097-5.6-7-10.266-7zm0 11.667A4.668 4.668 0 015.6 7a4.668 4.668 0 014.667-4.667A4.668 4.668 0 0114.933 7a4.668 4.668 0 01-4.666 4.667zm0-7.467c-1.55 0-2.8 1.25-2.8 2.8 0 1.55 1.25 2.8 2.8 2.8 1.549 0 2.8-1.25 2.8-2.8 0-1.55-1.251-2.8-2.8-2.8z",
    fill: "#666"
  })));
}

export default SvgViews;